import {
  SET_TRATAMIENTOS,
  UPDATE_TRATAMIENTO_IN_ARRAY,
  ADD_TRATAMIENTO_IN_ARRAY,
  REMOVE_TRATAMIENTO_IN_ARRAY,
} from "./tratamientosTypes";

const initialState = [];
export const tratamientosReducers = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRATAMIENTOS:
      return action.payload;
    case UPDATE_TRATAMIENTO_IN_ARRAY:
      let idx = state.findIndex((it) => it.id === action.payload.id);
      let items = [...state];
      if (idx > -1) items[idx] = action.payload;
      return items;
    case REMOVE_TRATAMIENTO_IN_ARRAY:
      const filteredItems = state.filter((t) => t.id != action.payload.id);
      return filteredItems;
    case ADD_TRATAMIENTO_IN_ARRAY:
      return [action.payload, ...state];
    default:
      return state;
  }
};
